// @flow

import EventNames from '../constants/EventNames';
import type { Plugin } from './interfaces/Plugin';

export default class disableDraggingPlugin implements Plugin {
  elements: Array<HTMLElement>;

  /**
   * Create a new instance of a LazyLoadPlugin
   */
  constructor(elements: ?Array<HTMLElement>) {
    if (!document.body) return;

    if (!elements) {
      this.elements = [...document.body.querySelectorAll('[data-not-draggable]')];
    } else {
      this.elements = elements;
    }
  }

  /**
   * Activate the disable dragging plugin
   */
  activate(): void {
    this.elements.forEach((element: HTMLElement) => {
      element.addEventListener(EventNames.DRAG_START, (event: Event) => {
        event.preventDefault();
        return false;
      });
    });
  }
}
